export default __webpack_public_path__ + "static/media/DarkOtrosDocuments.af94a356.svg";